import {
  checkoutLoader,
  createAccountAction,
  pricesLoader,
  signInAction,
  signUpAction,
} from "./data";
import { CreateAccountView, SignInView, SignUpView } from "./views";

const authRoutes = [
  {
    path: "/sign-up",
    element: <SignUpView />,
    action: signUpAction,
    loader: pricesLoader,
  },

  {
    path: "/create-account",
    element: <CreateAccountView />,
    action: createAccountAction,
    loader: pricesLoader,
  },
  {
    path: "/checkout",
    loader: checkoutLoader,
  },
  {
    path: "/login",
    element: <SignInView />,
    action: signInAction,
  },
];

export default authRoutes;
